import { FC } from "react";
import Typography from "../../components/Typography";
import { customTokens } from "../../theme/theme";
import { usePromptWindowStyles } from "./AIClimateAssistant.styles";
import { Button } from "@fluentui/react-components";
import { ChevronDown20Regular } from "@fluentui/react-icons";
import { useDispatch, useSelector } from "react-redux";
import { setVisibleCount } from "../../store/slices/ClimateAssistantSlice";
import { RootState } from "../../store";
import { useIsMobile } from "../../hooks";

interface IPromptsWindow {
  handleSend: (customQuery?: string, topicName?: string) => Promise<void>;
}

const PromptsWindow: FC<IPromptsWindow> = ({ handleSend }) => {
  const styles = usePromptWindowStyles();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const { promptList, showMore, visibleCount } = useSelector(
    (state: RootState) => state.climateAssistant
  );

  const handleShowMore = () => {
    dispatch(setVisibleCount(Math.min(visibleCount + 3, promptList.length)));
  };

  const visibleCards = promptList.slice(0, visibleCount);
  const hasMore = visibleCount < promptList.length;

  return (
    <div className={styles.promptWindow}>
      <div>
        <div className={styles.promptContainer}>
          {visibleCards.map((item) => {
            return (
              <div
                key={item.id}
                className={styles.promptBox}
                onClick={() => handleSend(item.prompt, item.heading)}
              >
                {item.tags.map((tag) => {
                  return (
                    <div className={styles.tagWrapper} key={tag.tagName}>
                      <div
                        className={styles.tag}
                        style={{ backgroundColor: tag.backgroundColor }}
                      >
                        <Typography
                          variant="caption1"
                          tabletVariant="caption2"
                          color={tag.color}
                        >
                          {tag.tagName}
                        </Typography>
                      </div>
                    </div>
                  );
                })}

                <Typography
                  variant="bodyMRegular"
                  tabletVariant="body1"
                  color={customTokens.colorNeutralForeground2}
                >
                  {item.heading}
                </Typography>

                {!isMobile && (
                  <Typography
                    variant="body1"
                    tabletVariant="bodyXSRegular"
                    color={customTokens.colorNeutralForeground4}
                  >
                    {item.prompt}
                  </Typography>
                )}
              </div>
            );
          })}
        </div>

        {showMore && hasMore && (
          <Button
            appearance="transparent"
            icon={<ChevronDown20Regular />}
            className={styles.showMorePromptButton}
            onClick={handleShowMore}
            iconPosition="after"
          >
            Show more prompts
          </Button>
        )}
      </div>
    </div>
  );
};

export default PromptsWindow;
